import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import _ from "lodash";

import Card from "../Card";
import CommonStep from "../CommonStep";

const Step = ({
  step,
  title,
  helpModalTitle,
  name,
  children,
  totalSteps,
  complete,
  isLoading,
  help,
  footer,
  closeButtonText,
  confirmButtonText,
  confirmButtonVariant,
  closeButtonVariant,
  classes,
  rounded,
}) => {
  return (
    <CommonStep
      step={step}
      title={title}
      footer={footer}
      classes={classes}
      rounded={rounded}
      header={
        <>
          {_.isArray(help) && (
            <Card.HelpIcon
              help={help}
              helpModalTitle={helpModalTitle}
              closeButtonText={closeButtonText}
              confirmButtonText={confirmButtonText}
              confirmButtonVariant={confirmButtonVariant}
              closeButtonVariant={closeButtonVariant}
            />
          )}
          {!!step && (
            <>
              <Card.Counter
                name={name}
                className={classNames(classes.counter)}
                stepNumber={step}
                totalSteps={totalSteps}
              />
              <Card.CompleteStatus complete={complete} isLoading={isLoading} />
            </>
          )}
        </>
      }
    >
      {children}
    </CommonStep>
  );
};

Step.defaultProps = {
  classes: {},
  complete: false,
  isLoading: false,
  rounded: true,
  name: "",
};

Step.propTypes = {
  step: PropTypes.number,
  title: PropTypes.string,
  helpModalTitle: PropTypes.string,
  name: PropTypes.string,
  children: PropTypes.node,
  classes: PropTypes.object,
  totalSteps: PropTypes.number,
  complete: PropTypes.bool,
  isLoading: PropTypes.bool,
  help: PropTypes.array,
  footer: PropTypes.elementType,
  closeButtonText: PropTypes.string,
  confirmButtonText: PropTypes.string,
  confirmButtonVariant: PropTypes.string,
  closeButtonVariant: PropTypes.string,
  rounded: PropTypes.bool,
};

export default Step;
